import { Routes } from '@angular/router';
import { authGuard } from '../shared/auth/auth.guard';

export const ADMIN_ROUTES: Routes = [
  {
    path: 'admin/users',
    loadComponent: () =>
      import('./all-users/all-users.component').then(
        (com) => com.AllUsersComponent,
      ),
    title: 'Users',
    canActivate: [authGuard],
  },
  {
    path: 'admin/users/view-edit/:userId',
    loadComponent: () =>
      import('./user-view-edit/user-view-edit.component').then(
        (com) => com.UserViewEditComponent,
      ),
    title: 'Edit User',
    canActivate: [authGuard],
  },
  {
    path: 'admin/users/add',
    loadComponent: () =>
      import('./user-add/user-add.component').then(
        (com) => com.UserAddComponent,
      ),
    title: 'Add User',
    canActivate: [authGuard],
  },
];
